// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"61":"c585bcc8","207":"7444b181","343":"ac8103ec","453":"ddd5f842","478":"ebb91a62","488":"b6b9211b","517":"71714af8","645":"5706d3e8","865":"a3ed1f53","977":"17ff228d"}[chunkId] + ".chunk.js";
};